import React, { FC, useState } from 'react';
import { ActionMeta } from 'react-select';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { FieldWithValue } from 'api/tasks';
import { IMultiValue, Option } from 'components/atoms/select/types';
import { BaseSelect } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/base-select';

interface FieldProps {
  field: FieldWithValue;
  disabled?: boolean;
  onChange?: (selected: number[] | null, field: FieldWithValue) => void;
  isPlaceholderShown?: boolean;
}

export const MultiUserField: FC<FieldProps> = ({
  field,
  disabled = false,
  onChange,
  isPlaceholderShown = true,
}) => {
  const [state, setState] = useState<IMultiValue>(null);

  useDeepCompareEffect(() => {
    const value = field.value as number[];
    const values = (value ?? []).map(Number);
    const selected = (field.metaData?.options ?? []).filter((o) => {
      return values.includes(o.value);
    });

    setState(selected);
  }, [field]);

  const commit = (latest: IMultiValue) => {
    if (onChange) {
      onChange(latest?.map((s) => Number(s.value)) || null, field);
    }
  };

  const handleChange = (
    latest: IMultiValue,
    { action }: ActionMeta<Option>,
  ) => {
    setState(latest);

    if (action === 'clear') {
      commit(latest);
    }
  };

  return (
    <BaseSelect
      isMulti
      type="user"
      disabled={disabled}
      closeMenuOnSelect={false}
      value={state}
      options={field.metaData?.options}
      onChange={handleChange}
      onMenuClose={() => commit(state)}
      data-cy={`right.content.multi.user.${field.fieldLabel}`}
      styles={{
        valueContainer: (base) => ({
          ...base,
          maxHeight: '44px',
          overflow: 'auto',
        }),
      }}
      isPlaceholderShown={isPlaceholderShown}
    />
  );
};
